export default {
  props: ["icon"],
  mounted() {}
};